import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HtmlTemplateService {

  constructor() { }

  getDubbleImageTemplate(template: any, point: any) {
    return `<div class="inner-html-text">
    <div>
        <p class="point-detail">
        ${template.templete_title} <span>${point} </span>
        </p>
    </div>
    <div class="program-images">
        <div>
            <img src="${template.templete_wrong_img}" alt="">
        </div>
        <div>
            <img src="${template.temple_right_img}" alt="">
        </div>
    </div>
    <div class="intraction">
        <p> ${template.image_insruction} </p>
    </div>
    <div class="heading-wrapper">
        <p class="font-primary">
     ${template.instruction}
     
        </p>
    </div>

    <div class="intraction-wrapper common-border">
        <span class="font-primary"> 1</span>
        <p>
            ${template.templete_insruction_one}

        </p>
    </div>
    <div class="intraction-wrapper common-border">
        <span class="font-primary"> 2</span>
        <p>
            ${template.templete_insruction_two}
        </p>
    </div>
    <div class="intraction-wrapper">
        <span class="font-primary">
            3
        </span>
        <p>
            ${template.templete_insruction_three}
        </p>
    </div>
</div>`
  }

  getSingleImageTemplate(template: any, point: any) {
    return `<div class="inner-html-text">
    <div>
        <p class="point-detail">
        ${template.templete_title} <span>${point} </span>
        </p>
    </div>
    <div class="program-images">
        <div>
            <img src="${template.single_image}" alt="">
        </div>
    </div>
    <div class="intraction">
        <p> ${template.image_insruction} </p>
    </div>
    <div class="heading-wrapper">
        <p class="font-primary">
        ${template.instruction}

        </p>
    </div>
    <div class="intraction-wrapper common-border">
        <span class="font-primary"> 1</span>
        <p>
            ${template.templete_insruction_one}
        </p>
    </div>
    <div class="intraction-wrapper common-border">
        <span class="font-primary"> 2</span>
        <p>
            ${template.templete_insruction_two}
        </p>
    </div>
    <div class="intraction-wrapper">
        <span class="font-primary">
            3
        </span>
        <p>
            ${template.templete_insruction_three}
        </p>
    </div>
</div>`
  }


  ChillerVisibitlityDoubbelImage(template: any, point: any) {
    return `
    <div class="inner-html-text">
  <div>
    <p class="point-detail"> ${template.templete_title}
      <span>${point} </span> </p>
  </div>
  <div class="program-images">
  <div>
  <img src="${template.templete_wrong_img}" alt="">
</div>
<div>
  <img src="${template.temple_right_img}" alt="">
</div>
  </div>
  <div class="intraction-view" id="view" (click)="viewProgram()">
    <p class="font-primary"> View Planogram
    </p>
  </div>
  <div class="heading-wrapper">
    <p class="font-primary">      ${template.instruction}

    </p>
  </div>
  <div class="intraction-wrapper common-border"> <span class="font-primary"> 1
    </span>
    <p> ${template.templete_insruction_one}
    </p>
  </div>
  <div class="intraction-wrapper common-border"> <span class="font-primary"> 2
    </span>
    <p> ${template.templete_insruction_two}
    </p>
  </div>
  <div class="intraction-wrapper"> <span class="font-primary"> 3
    </span>
    <p> ${template.templete_insruction_three}
    </p>
  </div>
</div>
    `
  }


  ChillerVisibitlitySinglelImage(template: any, point: any) {
    return `
    <div class="inner-html-text">
  <div>
    <p class="point-detail"> ${template.templete_title}
      <span>${point} </span> </p>
  </div>
  <div class="program-images">
  <div>
  <img src="${template.single_image}" alt="">
</div>
  </div>
  <div class="intraction-view" id="view" (click)="viewProgram()">
    <p class="font-primary"> View Planogram
    </p>
  </div>
  <div class="heading-wrapper">
    <p class="font-primary">      ${template.instruction}

    </p>
  </div>
  <div class="intraction-wrapper common-border"> <span class="font-primary"> 1
    </span>
    <p> ${template.templete_insruction_one}
    </p>
  </div>
  <div class="intraction-wrapper common-border"> <span class="font-primary"> 2
    </span>
    <p> ${template.templete_insruction_two}
    </p>
  </div>
  <div class="intraction-wrapper"> <span class="font-primary"> 3
    </span>
    <p> ${template.templete_insruction_three}
    </p>
  </div>
</div>
    `
  }

  posmDubbleImage(template: any, point: any){
    return `
    <div class="inner-html-text">
<div>
<p class="point-detail">
${template.templete_title}
<span>${point} </span>
</p>
</div>
<div class="program-images">
<div>
<img src="${template.templete_wrong_img}" alt="">
<p>
${template.image_insruction_wrong}
</p>
</div>
<div>
<img src="${template.temple_right_img}" alt="">
<p>
${template.image_insruction_right}
</p>
</div>
</div>
<div class="heading-wrapper">
<p class="font-primary">     ${template.instruction}

</p>
</div>
<div class="intraction-wrapper common-border">
<span class="font-primary">1
</span>
<p>${template.templete_insruction_one}
</p>
</div>
<div class="intraction-wrapper common-border"><span class="font-primary">2
</span>
<p>${template.templete_insruction_two}
</p>
</div>
<div class="intraction-wrapper">
<span class="font-primary">3
</span>
<p>
${template.templete_insruction_three}
</p>
</div>
</div>
    `
  }


  posmSingleImage(template: any, point: any){
    return `
    <div class="inner-html-text">
<div>
<p class="point-detail">
${template.templete_title}
<span>${point} </span>
</p>
</div>
<div class="program-images">
<div>
<img src="${template.templete_wrong_img}" alt="">
<p>
     ${template.instruction}
</p>
</div>
</div>
<div class="heading-wrapper">
<p class="font-primary"> ${template.instruction}

</p>
</div>
<div class="intraction-wrapper common-border">
<span class="font-primary">1
</span>
<p>${template.templete_insruction_one}
</p>
</div>
<div class="intraction-wrapper common-border"><span class="font-primary">2
</span>
<p>${template.templete_insruction_two}
</p>
</div>
<div class="intraction-wrapper">
<span class="font-primary">3
</span>
<p>
${template.templete_insruction_three}
</p>
</div>
</div>
    `
  }
}


